<i18n src="../../locales/lang.json"></i18n>
<template>
  <div>
    <div class="container-fluid">
      <div class="col-12" style="max-height:calc(100vh - 150px);overflow-y:auto">
        <div v-bind:class="customizeClass">
          <div class="row mt-3 mb-3">
            <div class="col-11 px-0">
              <button type="button" @click="copy" class="btn btn-light col-12"><i class="icon-link mt-1 pull-left"></i>{{$t('copy_url')}}</button>
            </div>
            <div class="col-1 pl-1">
              <qr-invite-button ref="qrbutton" class="" style="line-height:35px;"></qr-invite-button>
            </div>
            <div class="col-12 mt-1 text-center custom-form-label" v-show="confirmCopy == true">
              <label class="custom-form-label">{{$t('copied_to_clipboard')}}</label>
            </div>
          </div>        
        </div>
       
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "invite-user-share",
    components: {
     
    },
    props: {
    },
    data() {
      return {
        teamId: -1,
        index: 0,
        link: '',
        siteUniqueId: '',
        confirmCopy: false,
        qrlink: null,
      };
    },
    methods: {
      copy_old() {
        this.$refs.clone.focus();
        document.execCommand('copy');
      },
      async copy() {
        var thisContex = this;
        var text = this.link;
        //https://stackoverflow.com/questions/69438702/why-does-navigator-clipboard-writetext-not-copy-text-to-clipboard-if-it-is-pro
        return new Promise((resolve, reject) => {
          if (typeof navigator !== "undefined" && typeof navigator.clipboard !== "undefined" && navigator.permissions !== "undefined" && typeof ClipboardItem !== "undefined") {
            const type = "text/plain";
            const blob = new Blob([text], { type });
            const data = [new ClipboardItem({ [type]: blob })];
            navigator.permissions.query({ name: "clipboard-write" }).then((permission) => {
              if (permission.state === "granted" || permission.state === "prompt") {
                navigator.clipboard.write(data).then(resolve, reject).catch(reject);
                thisContex.confirmCopy = true;
              }
              else {
                reject(new Error("Permission not granted!"));
              }
            });
          }
          else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";
            textarea.style.width = '2em';
            textarea.style.height = '2em';
            textarea.style.padding = 0;
            textarea.style.border = 'none';
            textarea.style.outline = 'none';
            textarea.style.boxShadow = 'none';
            textarea.style.background = 'transparent';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            try {
              document.execCommand("copy");
              document.body.removeChild(textarea);
              thisContex.confirmCopy = true;
              resolve();
            }
            catch (e) {
              document.body.removeChild(textarea);
              
              reject(e);
            }
          }
          else {
            reject(new Error("None of copying methods are supported by this browser!"));
          }
        });
      },
      copy_old3() {
        var el = document.createElement('textarea');
        el.setAttribute('readonly', false);
        el.contentEditable = true;
        el.value = this.link;;
        el.style.position = 'absolute';
        el.style.left = '-9999px';

        document.body.appendChild(el);

        el.select();
        el.setSelectionRange(0, 99999); // For mobile devices

        // Copy the text inside the text field
        navigator.clipboard.writeText(el.value);

        document.body.removeChild(el);

        this.confirmCopy = true;
      },

      copy_old2() {
        var el = document.createElement('textarea');
        el.setAttribute('readonly', false);
        el.contentEditable = true;
        el.value = this.link;

        //el.contentEditable = true;
        //el.readOnly = oldReadOnly;
        //el.contentEditable('contenteditable', 'true');

        el.style.position = 'absolute';
        el.style.left = '-9999px';

        document.body.appendChild(el);

        /*
        https://stackoverflow.com/questions/34045777/copy-to-clipboard-using-javascript-in-ios
        */
        
        var range = document.createRange();
        range.selectNodeContents(el);
        var s = window.getSelection();
        s.removeAllRanges();
        s.addRange(range);

        el.setSelectionRange(0, 999999); // A big number, to cover anything that could be inside the element.

        document.execCommand('copy');

        document.body.removeChild(el);

        this.confirmCopy = true;
      },
      
      getId() {
        return this._uid;
      },

      getSiteUniqueId() {
        try {
          var url = '/api/Sites/v1/detail';
          this.$http.get(url).then(async response => {
            var data = response.data;
            this.siteUniqueId = data.UniqueId;
            this.open(-1);
            this.$forceUpdate();
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },

      open(teamId) {
        this.emails = [];
        this.index = 0;        
        //this.emails.push({ id: this.index, email: '' });
        //Vue.set(this, "emails", this.emails)
        //this.index++;
        this.teamId = teamId;

        this.$refs.qrbutton.lang = this.$store.getLocale()
        if (this.teamId > 0) {
          this.$refs.qrbutton.teamid = '' + this.teamId;
          this.link = window.location.origin + '/link/' + this.siteUniqueId + '/register/' + this.teamId + '?lang=' + this.$store.getLocale();
        } else {
          this.$refs.qrbutton.teamid = null;
          this.link = window.location.origin + '/link/' + this.siteUniqueId + '/register' + '?lang=' + this.$store.getLocale();
        }
        this.$forceUpdate();
      },

     

    },
    computed: {

    },
    watch: {

    },
    mounted() {
      this.getSiteUniqueId();
    },
    created() {

    },
  };

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/user/invite-user-share.vue